import moment from 'moment';

export default {
  methods: {
    formatarData(date, placeholderNull = "") {
      return (date && moment(date).year() > 1900) ? moment(date).format('L') : placeholderNull;
    },
    dataIso(date){
      return date ? moment(date).format(moment.HTML5_FMT.DATE) : null;
    },
    formatarDataHora(date, placeholderNull= ""){
      return date ? moment(date).format('LLLL') : placeholderNull;
    },
    formatarHora(date, placeholderNull = ""){
      return date ? moment(date).format('LT') : placeholderNull;
    },
    verificarEformatarHora(date){
      let momentHora = moment(date, undefined, true);
      return !momentHora.isValid() ? date : momentHora.format("LT");
    },
    parseHora(hora){
      return moment(hora, "HH:mm")
    },
    formatarDataFormato(date, placeholderNull = "", formato = "L") {
      return date ? moment(date).format(formato) : placeholderNull;
    },
  }
}
